import dayjs from 'dayjs';
import localeData from 'dayjs/plugin/localeData';
import {ScheduleCalendarType} from '../types';

dayjs.extend(localeData);
dayjs.localeData().firstDayOfWeek();

/**
 * Returns period, from date/time inclusive and to exclusive,
 * e.g. ('2021-02-24', 'day') => ('2021-02-24T00:00:00', '2021-02-24T23:59:59');
 * @param date
 * @param calendarType
 */
export const getPeriod = (
  date: Date | string,
  calendarType: ScheduleCalendarType,
): {from: Date; to: Date} => {
  const djDate = dayjs(date);

  if (calendarType === 'week') {
    // Force sunday to be the last day of the week by shifting all
    // days one left
    let day = djDate.day();
    if (day === 0) day = 6;
    else day--;

    let djFrom = djDate.subtract(day, 'day').startOf('day');
    let djTo = djDate.add(6 - day, 'day').endOf('day');

    return {from: djFrom.toDate(), to: djTo.toDate()};
  }

  return {
    from: djDate.startOf(calendarType).toDate(),
    to: djDate.endOf(calendarType).toDate(),
  };
};
